
import React, { Component } from 'react';

class AdditionalPages extends Component {

  render() {
    return (
      <li className="dropdown">
        <a className="dropdown-toggle" href="#" //eslint-disable-line
        >
          Additional Pages <i className="fa fa-angle-down"></i>
        </a>
        <ul className="dropdown-menu">
          <li><a href="/Sermons">Sermons</a></li>
          <li><a href="/Events">Upcoming Events</a></li>
          <li><a href="/MinistryTeam">Ministry Team</a></li>
          <li className="dropdown-submenu"><a href="#" //eslint-disable-line
          >Ministries</a>
            <ul className="dropdown-menu">
              <li><a href="/YouthMinistry">Youth Ministry</a></li>
              <li><a href="/ChildrensMinistry">Children's Ministry</a></li>
              <li><a href="/ConnectGroups">Connect Groups</a></li>
              <li><a href="/MercyMinistry">Mercy Ministry</a></li>
              <li><a href="/PastoralCare">Pastoral Care</a></li>
              <li><a href="/Prayer">Prayer</a></li>
              <li><a href="/LittleSquirts">Little Squirts</a></li>
              <li><a href="/EnglishHub">English Hub</a></li>
            </ul>
          </li>
          <li className="dropdown-submenu"><a href="#" //eslint-disable-line
          >Support</a>
            <ul className="dropdown-menu">
              <li><a href="/SupportUs">Support Us</a></li>
              <li><a href="/MissionsWeSupport">Missions We Support</a></li>
            </ul>
          </li>
          <li><a href="/Resources">Other Resources</a></li>
          <li><a href="/ParentingArticles">Parenting Articles</a></li>
          <li><a href="/MemberInfo">Member Details Form</a></li>
          <li><a href="/Connect">Connection Card</a></li>
        </ul>
      </li>
    );
  }
}

export default AdditionalPages;
